import { RelayLog } from '@/common/api/params/relay'
import { relayStatusBadgeType, relayStatusLabel } from '@/common/app/modules/relay'
import { dateTimeStr } from '@/common/util/date'

import Badge from '@/components/view/atoms/badge/Badge'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props {
  log: RelayLog
}

const RelayLogListRow = ({ log }: Props) => (
  <TableRow>
    <TableRowItem>
      <Text>{log.id}</Text>
    </TableRowItem>
    <TableRowItem>
      <Text nowrap>{log.tenant_id}</Text>
    </TableRowItem>
    <TableRowItem width={200}>
      <Text truncate>{log.filename}</Text>
    </TableRowItem>
    <TableRowItem>
      <Badge badgeType={relayStatusBadgeType(log.status)}>{relayStatusLabel(log.status)}</Badge>
    </TableRowItem>
    <TableRowItem width={200}>
      {log.detail ? (
        <Text truncate color={TextColor.SECONDARY}>
          {log.detail}
        </Text>
      ) : (
        <Text color={TextColor.SECONDARY}>-</Text>
      )}
    </TableRowItem>
    <TableRowItem>
      {log.created_at ? (
        <Text nowrap>{dateTimeStr(log.created_at)}</Text>
      ) : (
        <Text color={TextColor.SECONDARY}>-</Text>
      )}
    </TableRowItem>
  </TableRow>
)

export default RelayLogListRow
